import React from 'react';
import { FormikConfig, FormikValues } from "formik";

export interface FormikStepProps
    extends Pick<FormikConfig<FormikValues>, 'validationSchema' | 'validate'> {
    label: string;
    hideStep?: (initialValues: FormikValues, values: FormikValues) => boolean;
    children: React.ReactElement;
}

export function FormikStep(props: FormikStepProps) {
    return <>{props.children}</>;
}